import { Middleware } from '@reduxjs/toolkit';

import mapActions from './mapActions';

/**
 * Analytics Middleware intercepts dispatched actions so the payload and state
 * can be mapped, formatted and sent to the window.dataLayer array. This is then picked
 * up in Google Tag Manager and Google Analytics.
 */
const analytics: Middleware = (getStore) => (next) => (action) => {
  mapActions(action, getStore.getState());
  return next(action);
};

export default analytics;
